import { Pipe, PipeTransform } from '@angular/core';
import { Reservation } from '@model/reservation';
import { ReservationType } from '@model/tables-plan';
import moment from 'moment';
import { Common } from 'src/app/lib/common-methods';
import { ReservationService } from 'src/app/lib/reservation.service';

@Pipe({
  name: 'tableSlotStyle'
})
export class TableSlotStylePipe implements PipeTransform {

  constructor(private reservationService: ReservationService) {

  }

  transform(value: Reservation | null, ...args: unknown[]): unknown {

    const reservations = args[0] as Reservation[];
    const conflictingReservations: Reservation[] = args[1] as Reservation[];

    if (reservations == null || reservations.length <= 0) {
      return 'timeslot hidden';
    }

    let styleClass = ' empty';

    let conflictedSlot = conflictingReservations.some(r => r.reservationDetails.reservationId === value?.reservationDetails.reservationId) 
      ? ' conflicted_slot' 
      : '';
     
    if (value != null) {
      const reservationType = this.reservationService.statusToType(value?.reservationDetails.reservationsStatus);
      const expirationTime = this.reservationService.isReservationExpiredTime(value);

      if (expirationTime.returnTime) {
        styleClass = ' return_time_bell';
      } else if (expirationTime.arrivalTime) {
        styleClass = ' arrival_time_turtle';
      } else if (reservationType != null
        && (reservationType == ReservationType.Seated || value?.reservationDetails.reservationsStatus === 'CheckedIn(Partial)')) {
        styleClass = ' conflict';
      } else {
        styleClass = ' arrival_time_normal';
      }
    }

    return `timeslot${styleClass}${conflictedSlot}`;
  }

}

@Pipe({
  name: 'tableSlotProgress'
})
export class TableSlotProgressPipe implements PipeTransform {

  transform(value: Reservation | null, ...args: unknown[]): unknown {

    if (value?.reservationDetails == null) {
      return { width: '0' };
    }

    const { arrivalTime, returnTime, duration } = value.reservationDetails;

    if (arrivalTime == null || !moment(arrivalTime).isValid()) {
      return { width: '0' };
    }

    const arrivalDate = moment(arrivalTime).toDate();

    let rDuration: number | undefined = 120; // in minutes

    if (returnTime == null || !moment(returnTime).isValid()) {
      rDuration = duration;
    } else {
      const targetDate = moment(returnTime).toDate();

      // Find the difference between the two dates in milliseconds
      const differenceMillis = targetDate.getTime() - arrivalDate.getTime();

      // Convert the difference to minutes
      rDuration = differenceMillis / (60 * 1000);
    }

    // Calculate the elapsed time in milliseconds
    const elapsedTime = new Date().getTime() - arrivalDate.getTime();

    // Calculate the progress as a percentage
    let progress = 0;

    if (rDuration != null && rDuration > 0) {
      progress = (100 * elapsedTime / ((rDuration ?? 0) * 60 * 1000));
    }

    if (progress > 100) {
      progress = 100;
    }

    return { width: `${progress}%` };
  }

}

@Pipe({
  name: 'tableSlotTime'
})
export class TableSlotTimePipe implements PipeTransform {

  transform(value: Reservation | null, ...args: unknown[]): unknown {

    if (value == null) {
      return '';
    }

    return moment(value.reservationDetails.arrivalTime).format('HH:mm');
  }

}
